"use client"
import { ProductCard } from "@/components/common/product-card"
import SkeletonLoader from "../latest-release/skeleton-latest-release"

import Heading from "@/components/common/re-usable-components/heading"
import CustomButton from "@/components/common/re-usable-components/view-more"

export const ExploreProducts = ({ products }: { products: any }) => {
  if (products?.length === 0)
    return (
      <div className="w-full h-full flex flex-col justify-center items-center my-2">
        {/* Display Skeleton as backdrop */}
        <SkeletonLoader cardCount={10} />
      </div>
    )

  return (
    <div className="w-full h-full flex flex-col justify-center items-center my-2 lg:my-0">
      <Heading heading="Explore Products" className=" lg:mb-6" />

      {/* <div className=" w-full h-full flex flex-wrap justify-around items-center  lg:px-3 mb-2 lg:mb-8"> */}
      <div className="flex flex-col gap-8 w-full h-full justify-center items-center">
        <div className="w-full h-full grid grid-cols-2 xs:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 justify-items-center  gap-y-5 lg:gap-y-8 lg:px-3 lg:mb-24 mb-2 max-sm:mb-8">
          {products?.slice(0, 10).map((product: any, i: number) => (
            <ProductCard
              product={product}
              res={3}
              key={`${i}-${product.device_name}`}
            />
          ))}
        </div>
        <CustomButton href="/all-products" />
      </div>
    </div>
  )
}
